module.exports = __webpack_public_path__ + "static/media/5.d67fee1a.jpg";